var map; //<-- This is now available to both event listeners and the initialize() function
var mapCenter; // Declare a variable to store the center of the map
var centerMarker; // declare your marker

var conLat = ranJsVariables.contactLat;
var conLng = ranJsVariables.contactLng;

function initializeMap() {
    var mapOptions = {
        // How zoomed in you want the map to start at (always required)
        zoom: 16,
        panControl: false,
        rotateControl: false,
        scaleControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false,
        zoomControl: false,
        styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#736c68"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#e7e6e5"}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"on"},{"color":"#d4e4d3"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#f5f5f5"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#d4e4d3"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#f5f5f5"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#e7e6e5"},{"gamma":"0.65"},{"lightness":"0"}]},{"featureType":"transit","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#aad5df"}]}]
    };

    mapCenter = new google.maps.LatLng(conLat, conLng);

    if ($('#contacts-map').length > 0) {
        map = new google.maps.Map(document.getElementById("contacts-map"), mapOptions);
        map.setCenter(mapCenter);
    }

    var image = '../content/themes/ran/assets/img/pin.png';

    // Create a new marker and add it to the map
    centerMarker = new google.maps.Marker({
        position: new google.maps.LatLng(conLat, conLng),
        map: map,
        icon: image,
        title: 'RAN'
    });
}

if ($('#contacts-map').length > 0) {
    google.maps.event.addDomListener(window, 'load', initializeMap);
}